// extracted by mini-css-extract-plugin
module.exports = {"schoolCentre_warp":"schoolCentre_schoolCentre_warp__3SUyT","EmptyConet_CONT":"schoolCentre_EmptyConet_CONT__nfDng"};